import { render } from "./TotalSalesByData.vue?vue&type=template&id=5b6466e6"
import script from "./TotalSalesByData.vue?vue&type=script&lang=js"
export * from "./TotalSalesByData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__